window.RadioTraderAccessoryFinderData = [

  /* =========================================================
     MOTOROLA — HANDHELD
  ========================================================= */

  {
    type: "Handheld",
    manufacturer: "Motorola",
    model: "R2",
    tags: [
      "R2 Accessories",
      "R2 Carry Cases",
      "R2 Earpieces"
    ]
  },

  {
    type: "Handheld",
    manufacturer: "Motorola",
    model: "R5",
    radioHandle: "motorola-r5-lkp-digital-handheld-radio",
    tags: [
      "R5 Accessories"
    ]
  },

  {
    type: "Handheld",
    manufacturer: "Motorola",
    model: "R7",
    tags: [
      "R7 Series Accessories",
      "R7 Series Carry Cases"
    ]
  },

  {
    type: "Handheld",
    manufacturer: "Motorola",
    model: "R7Ex",
    tags: [
      "R7Ex Series Accessories"
    ]
  },

  {
    type: "Handheld",
    manufacturer: "Motorola",
    model: "DP1400",
    tags: [
      "DP1400 Accessories",
      "DP1400 Batteries",
      "DP1400 Carry Cases",
      "DP1400 Earpieces"
    ]
  },

  {
    type: "Handheld",
    manufacturer: "Motorola",
    model: "DP2400",
    tags: [
      "DP2000 Series Accessories",
      "DP2000 Series Batteries",
      "DP2000 Series Carry Cases",
      "DP2000 Series Earpieces"
    ]
  },

  {
    type: "Handheld",
    manufacturer: "Motorola",
    model: "DP2400e",
    tags: [
      "DP2000 Series Accessories",
      "DP2000 Series Batteries",
      "DP2000 Series Carry Cases",
      "DP2000 Series Earpieces"
    ]
  },

  {
    type: "Handheld",
    manufacturer: "Motorola",
    model: "DP2600",
    tags: [
      "DP2000 Series Accessories",
      "DP2000 Series Batteries",
      "DP2000 Series Carry Cases",
      "DP2000 Series Earpieces"
    ]
  },

  {
    type: "Handheld",
    manufacturer: "Motorola",
    model: "DP2600e",
    tags: [
      "DP2000 Series Accessories",
      "DP2000 Series Batteries",
      "DP2000 Series Carry Cases",
      "DP2000 Series Earpieces"
    ]
  },

  {
    type: "Handheld",
    manufacturer: "Motorola",
    model: "DP3441e",
    tags: [
      "DP3XX1e Series Accessories",
      "DP3XX1e Series Batteries",
      "DP3XX1e Series Chargers",
      "DP3XX1e Series Earpieces"
    ]
  },

  {
    type: "Handheld",
    manufacturer: "Motorola",
    model: "DP3661e",
    tags: [
      "DP3XX1e Series Accessories",
      "DP3XX1e Series Batteries",
      "DP3XX1e Series Chargers",
      "DP3XX1e Series Earpieces"
    ]
  },

  {
    type: "Handheld",
    manufacturer: "Motorola",
    model: "DP4400e",
    tags: [
      "DP4000e Series Accessories"
    ]
  },

  {
    type: "Handheld",
    manufacturer: "Motorola",
    model: "DP4401e",
    tags: [
      "DP4000e Series Accessories"
    ]
  },

  {
    type: "Handheld",
    manufacturer: "Motorola",
    model: "DP4600e",
    tags: [
      "DP4000e Series Accessories"
    ]
  },

  {
    type: "Handheld",
    manufacturer: "Motorola",
    model: "DP4601e",
    tags: [
      "DP4000e Series Accessories"
    ]
  },

  {
    type: "Handheld",
    manufacturer: "Motorola",
    model: "DP4800e",
    tags: [
      "DP4000e Series Accessories"
    ]
  },

  {
    type: "Handheld",
    manufacturer: "Motorola",
    model: "DP4801e",
    tags: [
      "DP4000e Series Accessories"
    ]
  },

  {
    type: "Handheld",
    manufacturer: "Motorola",
    model: "DP4401Ex",
    tags: [
      "DP4000 Atex Series Accessories"
    ]
  },

  {
    type: "Handheld",
    manufacturer: "Motorola",
    model: "DP4801Ex",
    tags: [
      "DP4000 Atex Series Accessories"
    ]
  },

  {
    type: "Handheld",
    manufacturer: "Motorola",
    model: "SL1600",
    tags: [
      "SL Series Accessories"
    ]
  },

  {
    type: "Handheld",
    manufacturer: "Motorola",
    model: "SL2600",
    tags: [
      "SL Series Accessories"
    ]
  },

  {
    type: "Handheld",
    manufacturer: "Motorola",
    model: "SL4000",
    tags: [
      "SL Series Accessories"
    ]
  },

  {
    type: "Handheld",
    manufacturer: "Motorola",
    model: "SL4000e",
    tags: [
      "SL Series Accessories"
    ]
  },

  {
    type: "Handheld",
    manufacturer: "Motorola",
    model: "SL4010e",
    tags: [
      "SL Series Accessories"
    ]
  },

  {
    type: "Handheld",
    manufacturer: "Motorola",
    model: "XT185",
    tags: [
      "XT185 Accessories"
    ]
  },

  {
    type: "Handheld",
    manufacturer: "Motorola",
    model: "XT420",
    tags: [
      "XT400 Series Accessories"
    ]
  },

  {
    type: "Handheld",
    manufacturer: "Motorola",
    model: "XT460",
    tags: [
      "XT400 Series Accessories"
    ]
  },

  {
    type: "Handheld",
    manufacturer: "Motorola",
    model: "CLK446",
    tags: [
      "CLK446 Accessories"
    ]
  },

  {
    type: "Handheld",
    manufacturer: "Motorola",
    model: "CLPe",
    tags: [
      "CLPe Accessories"
    ]
  },

  {
    type: "Handheld",
    manufacturer: "Motorola",
    model: "CLR446",
    tags: [
      "CLR446 Accessories"
    ]
  },

  {
    type: "Handheld",
    manufacturer: "Motorola",
    model: "EVX-S24",
    tags: [
      "EVX-S24 Accessories"
    ]
  },


  /* =========================================================
     MOTOROLA — PoC
  ========================================================= */

  {
    type: "PoC Handheld",
    manufacturer: "Motorola",
    model: "TLK100",
    tags: [
      "TLK100 Series Accessories"
    ]
  },

  {
    type: "PoC Handheld",
    manufacturer: "Motorola",
    model: "Evolve",
    tags: [
      "Evolve Accessories"
    ]
  },


  /* =========================================================
     MOTOROLA — MOBILE
  ========================================================= */

  {
    type: "Mobile",
    manufacturer: "Motorola",
    model: "DM1400",
    tags: [
      "DM1400 Accessories"
    ]
  },

  {
    type: "Mobile",
    manufacturer: "Motorola",
    model: "DM4400e",
    tags: [
      "DM4000e Series Accessories"
    ]
  },

  {
    type: "Mobile",
    manufacturer: "Motorola",
    model: "DM4401e",
    tags: [
      "DM4000e Series Accessories"
    ]
  },

  {
    type: "Mobile",
    manufacturer: "Motorola",
    model: "DM4600e",
    tags: [
      "DM4000e Series Accessories"
    ]
  },

  {
    type: "Mobile",
    manufacturer: "Motorola",
    model: "DM4601e",
    tags: [
      "DM4000e Series Accessories"
    ]
  },

  {
    type: "Mobile",
    manufacturer: "Motorola",
    model: "GM340",
    tags: [
      "GM340 Accessories"
    ]
  },


  /* =========================================================
     MOTOROLA — REPEATERS
  ========================================================= */

  {
    type: "Repeater",
    manufacturer: "Motorola",
    model: "SLR1000",
    tags: [
      "SLR1000 Accessories"
    ]
  },

  {
    type: "Repeater",
    manufacturer: "Motorola",
    model: "SLR5500",
    tags: [
      "SLR5500 Accessories"
    ]
  },

  {
    type: "Repeater",
    manufacturer: "Motorola",
    model: "SLR8000",
    tags: [
      "SLR8000 Accessories"
    ]
  },

  {
    type: "Repeater",
    manufacturer: "Hytera",
    model: "E-PACK100",
    tags: [
      "E-PACK100 Accessories",
      "E-Pack 100 Accessories"
    ]
  },

  {
    type: "Repeater",
    manufacturer: "Hytera",
    model: "HR655",
    tags: [
      "HR655 Accessories",
      "HR Series Accessories"
    ]
  },

  {
    type: "Repeater",
    manufacturer: "Hytera",
    model: "HR1065",
    tags: [
      "HR1065 Accessories",
      "HR10 Series Accessories"
    ]
  },

  {
    type: "Repeater",
    manufacturer: "Hytera",
    model: "HR1065e",
    tags: [
      "HR1065e Accessories",
      "HR1065 Accessories",
      "HR10 Series Accessories"
    ]
  },

  {
    type: "Repeater",
    manufacturer: "Caltta",
    model: "PR900",
    tags: [
      "PR900 Accessories"
    ]
  },

  {
    type: "Repeater",
    manufacturer: "Icom",
    model: "IC-FR5100 / IC-FR6100",
    tags: [
      "IC-FR5100/6100 Accessories",
      "IC-FR5100 / IC-FR6100 Accessories"
    ]
  },

  {
    type: "Repeater",
    manufacturer: "Kenwood",
    model: "TKR-D710 / TKR-D810",
    tags: [
      "TKR-D710/D810 Accessories",
      "TKR-D710 / TKR-D810 Accessories"
    ]
  },


  /* =========================================================
     HYTERA — HANDHELD
  ========================================================= */

  {
    type: "Handheld",
    manufacturer: "Hytera",
    model: "AP325",
    tags: [
      "AP Series Accessories"
    ]
  },

  {
    type: "Handheld",
    manufacturer: "Hytera",
    model: "AP515",
    tags: [
      "AP Series Accessories"
    ]
  },

  {
    type: "Handheld",
    manufacturer: "Hytera",
    model: "AP525",
    tags: [
      "AP Series Accessories"
    ]
  },

  {
    type: "Handheld",
    manufacturer: "Hytera",
    model: "AP525LF",
    tags: [
      "AP Series Accessories"
    ]
  },

  {
    type: "Handheld",
    manufacturer: "Hytera",
    model: "AP585",
    tags: [
      "AP Series Accessories"
    ]
  },

  {
    type: "Handheld",
    manufacturer: "Hytera",
    model: "BP365",
    tags: [
      "BP Series Accessories"
    ]
  },

  {
    type: "Handheld",
    manufacturer: "Hytera",
    model: "BP515",
    tags: [
      "BP Series Accessories"
    ]
  },

  {
    type: "Handheld",
    manufacturer: "Hytera",
    model: "BP515LF",
    tags: [
      "BP Series Accessories"
    ]
  },

  {
    type: "Handheld",
    manufacturer: "Hytera",
    model: "BP565",
    tags: [
      "BP Series Accessories"
    ]
  },

  {
    type: "Handheld",
    manufacturer: "Hytera",
    model: "BD305LF",
    tags: [
      "BD Series Accessories"
    ]
  },

  {
    type: "Handheld",
    manufacturer: "Hytera",
    model: "BD505",
    tags: [
      "BD Series Accessories"
    ]
  },

  {
    type: "Handheld",
    manufacturer: "Hytera",
    model: "BD505LF",
    tags: [
      "BD Series Accessories"
    ]
  },

  {
    type: "Handheld",
    manufacturer: "Hytera",
    model: "BD615",
    tags: [
      "BD Series Accessories"
    ]
  },

  {
    type: "Handheld",
    manufacturer: "Hytera",
    model: "HP505",
    tags: [
      "HP Series Accessories"
    ]
  },

  {
    type: "Handheld",
    manufacturer: "Hytera",
    model: "HP565",
    tags: [
      "HP Series Accessories"
    ]
  },

  {
    type: "Handheld",
    manufacturer: "Hytera",
    model: "HP605",
    tags: [
      "HP Series Accessories"
    ]
  },

  {
    type: "Handheld",
    manufacturer: "Hytera",
    model: "HP685",
    tags: [
      "HP Series Accessories"
    ]
  },

  {
    type: "Handheld",
    manufacturer: "Hytera",
    model: "HP705",
    tags: [
      "HP Series Accessories"
    ]
  },

  {
    type: "Handheld",
    manufacturer: "Hytera",
    model: "HP785",
    tags: [
      "HP Series Accessories"
    ]
  },

  {
    type: "Handheld",
    manufacturer: "Hytera",
    model: "HP715Ex",
    tags: [
      "HP Series Accessories"
    ]
  },

  {
    type: "Handheld",
    manufacturer: "Hytera",
    model: "HP795Ex",
    tags: [
      "HP Series Accessories",
      "HP795Ex Accessories"
    ]
  },

  {
    type: "Handheld",
    manufacturer: "Hytera",
    model: "PD365",
    tags: [
      "PD Series Accessories",
      "PD365 Accessories"
    ]
  },

  {
    type: "Handheld",
    manufacturer: "Hytera",
    model: "PD365LF",
    tags: [
      "PD Series Accessories",
      "PD365 Accessories"
    ]
  },

  {
    type: "Handheld",
    manufacturer: "Hytera",
    model: "PD405",
    tags: [
      "PD Series Accessories",
      "PD405 Accessories"
    ]
  },

  {
    type: "Handheld",
    manufacturer: "Hytera",
    model: "PD415",
    tags: [
      "PD Series Accessories"
    ]
  },

  {
    type: "Handheld",
    manufacturer: "Hytera",
    model: "PD485",
    tags: [
      "PD Series Accessories"
    ]
  },

  {
    type: "Handheld",
    manufacturer: "Hytera",
    model: "PD485G",
    tags: [
      "PD Series Accessories"
    ]
  },

  {
    type: "Handheld",
    manufacturer: "Hytera",
    model: "PD505",
    tags: [
      "PD Series Accessories",
      "PD505 Accessories"
    ]
  },

  {
    type: "Handheld",
    manufacturer: "Hytera",
    model: "PD505LF",
    tags: [
      "PD Series Accessories",
      "PD505 Accessories"
    ]
  },

  {
    type: "Handheld",
    manufacturer: "Hytera",
    model: "PD565",
    tags: [
      "PD Series Accessories"
    ]
  },

  {
    type: "Handheld",
    manufacturer: "Hytera",
    model: "PD685",
    tags: [
      "PD Series Accessories"
    ]
  },

  {
    type: "Handheld",
    manufacturer: "Hytera",
    model: "PD685G",
    tags: [
      "PD Series Accessories"
    ]
  },

  {
    type: "Handheld",
    manufacturer: "Hytera",
    model: "PD705",
    tags: [
      "PD Series Accessories"
    ]
  },

  {
    type: "Handheld",
    manufacturer: "Hytera",
    model: "PD705LT",
    tags: [
      "PD Series Accessories"
    ]
  },

  {
    type: "Handheld",
    manufacturer: "Hytera",
    model: "PD785",
    tags: [
      "PD Series Accessories"
    ]
  },

  {
    type: "Handheld",
    manufacturer: "Hytera",
    model: "PD985",
    tags: [
      "PD Series Accessories",
      "PD985 Accessories"
    ]
  },


  /* =========================================================
     HYTERA — PoC
  ========================================================= */

  {
    type: "PoC Handheld",
    manufacturer: "Hytera",
    model: "PNC360S",
    tags: [
      "PNC Series Accessories"
    ]
  },

  {
    type: "PoC Handheld",
    manufacturer: "Hytera",
    model: "PNC380",
    tags: [
      "PNC Series Accessories"
    ]
  },

  {
    type: "PoC Handheld",
    manufacturer: "Hytera",
    model: "PNC380D",
    tags: [
      "PNC Series Accessories"
    ]
  },

  {
    type: "PoC Handheld",
    manufacturer: "Hytera",
    model: "PNC460",
    tags: [
      "PNC Series Accessories"
    ]
  },

  {
    type: "PoC Handheld",
    manufacturer: "Hytera",
    model: "PDC550",
    tags: [
      "PDC Series Accessories"
    ]
  },

  {
    type: "PoC Handheld",
    manufacturer: "Hytera",
    model: "PDC680",
    tags: [
      "PDC Series Accessories"
    ]
  },

  {
    type: "PoC Handheld",
    manufacturer: "Hytera",
    model: "PDC760",
    tags: [
      "PDC Series Accessories"
    ]
  },


  /* =========================================================
     HYTERA — MOBILE
  ========================================================= */

  {
    type: "Mobile",
    manufacturer: "Hytera",
    model: "HM655",
    tags: [
      "HM Series Accessories",
      "HM6 Series Accessories"
    ]
  },

  {
    type: "Mobile",
    manufacturer: "Hytera",
    model: "HM685",
    tags: [
      "HM Series Accessories",
      "HM6 Series Accessories"
    ]
  },

  {
    type: "Mobile",
    manufacturer: "Hytera",
    model: "HM785",
    tags: [
      "HM Series Accessories",
      "HM7 Series Accessories"
    ]
  },

  {
    type: "Mobile",
    manufacturer: "Hytera",
    model: "MD615",
    tags: [
      "MD6 Series Accessories"
    ]
  },

  {
    type: "Mobile",
    manufacturer: "Hytera",
    model: "MD625",
    tags: [
      "MD6 Series Accessories"
    ]
  },

  {
    type: "Mobile",
    manufacturer: "Hytera",
    model: "MNC360",
    tags: [
      "MNC360 Accessories"
    ]
  },


  /* =========================================================
     KENWOOD — HANDHELD
  ========================================================= */

  {
    type: "Handheld",
    manufacturer: "Kenwood",
    model: "NX-1200DE2",
    tags: [
      "NX-1 Series Accessories"
    ]
  },

  {
    type: "Handheld",
    manufacturer: "Kenwood",
    model: "NX-1200DE3",
    tags: [
      "NX-1 Series Accessories"
    ]
  },

  {
    type: "Handheld",
    manufacturer: "Kenwood",
    model: "NX-1300DE2",
    tags: [
      "NX-1 Series Accessories"
    ]
  },

  {
    type: "Handheld",
    manufacturer: "Kenwood",
    model: "NX-1300DE3",
    tags: [
      "NX-1 Series Accessories"
    ]
  },

  {
    type: "Handheld",
    manufacturer: "Kenwood",
    model: "NX-3220",
    tags: [
      "NX-3000 Series Accessories"
    ]
  },

  {
    type: "Handheld",
    manufacturer: "Kenwood",
    model: "NX-3300",
    tags: [
      "NX-3000 Series Accessories"
    ]
  },

  {
    type: "Handheld",
    manufacturer: "Kenwood",
    model: "NX-3320",
    tags: [
      "NX-3000 Series Accessories"
    ]
  },

  {
    type: "Handheld",
    manufacturer: "Kenwood",
    model: "TK-3501",
    tags: [
      "TK-3501 Accessories"
    ]
  },

  {
    type: "Handheld",
    manufacturer: "Kenwood",
    model: "TK-3701D",
    tags: [
      "TK-3701DE Accessories"
    ]
  },


  /* =========================================================
     KENWOOD — MOBILE
  ========================================================= */

  {
    type: "Mobile",
    manufacturer: "Kenwood",
    model: "NX-1700",
    tags: [
      "NX-1700/1800 Accessories"
    ]
  },

  {
    type: "Mobile",
    manufacturer: "Kenwood",
    model: "NX-1800",
    tags: [
      "NX-1700/1800 Accessories"
    ]
  },


  /* =========================================================
     ICOM — HANDHELD
  ========================================================= */

  {
    type: "Handheld",
    manufacturer: "Icom",
    model: "IC-F1000",
    tags: [
      "IC-F1000/2000 Accessories"
    ]
  },

  {
    type: "Handheld",
    manufacturer: "Icom",
    model: "IC-F2000",
    tags: [
      "IC-F1000/2000 Accessories"
    ]
  },

  {
    type: "Handheld",
    manufacturer: "Icom",
    model: "IC-F1100D",
    tags: [
      "IC-F1100D/F2100D Series Accessories"
    ]
  },

  {
    type: "Handheld",
    manufacturer: "Icom",
    model: "IC-F2100D",
    tags: [
      "IC-F1100D/F2100D Series Accessories"
    ]
  },

  {
    type: "Handheld",
    manufacturer: "Icom",
    model: "IC-F29",
    tags: [
      "IC-F29 Series Accessories"
    ]
  },

  {
    type: "Handheld",
    manufacturer: "Icom",
    model: "IC-F52D",
    tags: [
      "IC-F52D/F62D Series Accessories"
    ]
  },

  {
    type: "Handheld",
    manufacturer: "Icom",
    model: "IC-F62D",
    tags: [
      "IC-F52D/F62D Series Accessories"
    ]
  },

  {
    type: "Handheld",
    manufacturer: "Icom",
    model: "IC-U20SR",
    tags: [
      "IC-U20SR Accessories"
    ]
  },


  /* =========================================================
     ICOM — PoC
  ========================================================= */

  {
    type: "PoC Handheld",
    manufacturer: "Icom",
    model: "IP501H",
    tags: [
      "IP501H/IP503H Accessories"
    ]
  },

  {
    type: "PoC Handheld",
    manufacturer: "Icom",
    model: "IP503H",
    tags: [
      "IP501H/IP503H Accessories"
    ]
  },


  /* =========================================================
     ICOM — MOBILE
  ========================================================= */

  {
    type: "Mobile",
    manufacturer: "Icom",
    model: "IC-F5012",
    tags: [
      "IC-F5012/F6012 Accessories"
    ]
  },

  {
    type: "Mobile",
    manufacturer: "Icom",
    model: "IC-F6012",
    tags: [
      "IC-F5012/F6012 Accessories"
    ]
  },

  {
    type: "Mobile",
    manufacturer: "Icom",
    model: "IC-F5130D",
    tags: [
      "IC-F5130D/6130D Accessories"
    ]
  },

  {
    type: "Mobile",
    manufacturer: "Icom",
    model: "IC-F6130D",
    tags: [
      "IC-F5130D/6130D Accessories"
    ]
  },

  {
    type: "Mobile",
    manufacturer: "Icom",
    model: "IC-F5400D",
    tags: [
      "IC-F5400D/F6400D Accessories",
      "IC-F5400D/6400D Accessories"
    ]
  },

  {
    type: "Mobile",
    manufacturer: "Icom",
    model: "IC-F6400D",
    tags: [
      "IC-F5400D/F6400D Accessories",
      "IC-F5400D/6400D Accessories"
    ]
  },


  /* =========================================================
     TAIT
  ========================================================= */

  {
    type: "Mobile",
    manufacturer: "Tait",
    model: "TM8110",
    tags: [
      "TM-8110 Accessories"
    ]
  },


  /* =========================================================
     TELOX
  ========================================================= */

  {
    type: "PoC Handheld",
    manufacturer: "Telox",
    model: "TE320",
    tags: [
      "TE320 Accessories"
    ]
  },


  /* =========================================================
     SIYATA
  ========================================================= */

  {
    type: "PoC Handheld",
    manufacturer: "Siyata",
    model: "SD7",
    tags: [
      "SD7 Accessories"
    ]
  },


  /* =========================================================
     RUGGEAR
  ========================================================= */

  {
    type: "PoC Handheld",
    manufacturer: "RugGear",
    model: "RG360",
    tags: [
      "RG360 Accessories"
    ]
  },

  {
    type: "PoC Handheld",
    manufacturer: "RugGear",
    model: "RG725",
    tags: [
      "RG725 Accessories"
    ]
  },

  {
    type: "PoC Handheld",
    manufacturer: "RugGear",
    model: "RG750",
    tags: [
      "RG750 Accessories"
    ]
  }

];